function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "\n    cms-persona-quiz\n  ");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20,22.39A10.43,10.43,0,1,1,30.42,12,10.44,10.44,0,0,1,20,22.39Zm0-18.6A8.18,8.18,0,1,0,28.17,12,8.19,8.19,0,0,0,20,3.79Z",
  fill: "#231f20"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20,15.17a.94.94,0,0,1-.94-.94,3.37,3.37,0,0,1,1.72-3,1.78,1.78,0,0,0,1-1.75,1.8,1.8,0,0,0-3.58,0,.94.94,0,1,1-1.87,0,3.66,3.66,0,1,1,5.53,3.27c-.62.45-.93.67-.93,1.52A.94.94,0,0,1,20,15.17Z",
  fill: "#231f20"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 17.58,
  r: 1.21,
  fill: "#231f20"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M20,26.66a18.48,18.48,0,0,1,16,9.22H4a18.48,18.48,0,0,1,16-9.22m0-2.25A20.77,20.77,0,0,0,1.56,35.62,1.73,1.73,0,0,0,3.1,38.13H36.9a1.73,1.73,0,0,0,1.54-2.51A20.77,20.77,0,0,0,20,24.41Z",
  fill: "#231f20"
});

function SvgCmsPersonaQuiz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 40 40"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}

export default SvgCmsPersonaQuiz;